import { format, addMonths } from 'date-fns';
import { es } from 'date-fns/locale';

export interface DefaultPrize {
  month_year: string;
  prize_name: string;
  prize_description: string;
  prize_value: number;
  prize_type: 'ranking_winner';
  status: 'pending';
  isDefault: true;
}

export const DEFAULT_RANKING_PRIZES = [
  { position: 1, label: '1° Lugar', value: 40000, emoji: '🥇', color: 'amber' },
  { position: 2, label: '2° Lugar', value: 30000, emoji: '🥈', color: 'zinc' },
  { position: 3, label: '3° Lugar', value: 20000, emoji: '🥉', color: 'orange' },
];

export const DEFAULT_VOLUME_BONUSES = [
  { plan: 'bronce', planLabel: 'Bronce', quantity: 10, value: 12000, color: 'amber-700' },
  { plan: 'plata', planLabel: 'Plata', quantity: 10, value: 20000, color: 'zinc-400' },
  { plan: 'oro', planLabel: 'Oro', quantity: 10, value: 40000, color: 'amber-400' },
];

export const getDefaultPrizeForMonth = (monthYear: string): DefaultPrize => ({
  month_year: monthYear,
  prize_name: 'Premios del Ranking',
  prize_description: '1°: ₡40,000 | 2°: ₡30,000 | 3°: ₡20,000',
  prize_value: 40000,
  prize_type: 'ranking_winner',
  status: 'pending',
  isDefault: true,
});

export const generateMonthList = (count: number = 12): string[] => {
  const months: string[] = [];
  const now = new Date();
  
  for (let i = 0; i < count; i++) {
    const date = addMonths(now, i);
    months.push(format(date, 'yyyy-MM'));
  }
  
  return months;
};

export const formatMonthYearDisplay = (monthYear: string): string => {
  const [year, month] = monthYear.split('-');
  const date = new Date(parseInt(year), parseInt(month) - 1, 1);
  return format(date, 'MMMM yyyy', { locale: es });
};

export const formatCurrency = (value: number): string => {
  return `₡${value.toLocaleString()}`;
};
